export default __webpack_public_path__ + "static/media/cdn.010d4d2d.png";